<template>
  <transition name="fade">
    <div class="app-modal-overlay" v-if="show">
      <slot></slot>
    </div>
  </transition>
</template>

<script>
import AppModalPlugin from './AppModalPlugin.js';

export default {
  name: 'app-modal',

  props: {
    id: Number
  },

  data() {
    return {
      show: true
    };
  },

  beforeMount() {
    AppModalPlugin.event.$on('close', (id) => {
      if (id === this.id) {
        this.show = false;
        setTimeout(() => {
          this.$emit('remove', id);
        }, 500)
      }
    })
  }
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.app-modal-overlay {
  z-index: 100;
  position: fixed;
  display: flex;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 10px;
  background-color: rgba(6, 19, 50, .8);
  overflow: auto;
}

.app-modal-overlay > * {
  margin: auto;
}
</style>
